module.exports = __webpack_public_path__ + "static/media/virbac_20210528.5e6c0a31.pdf";